import { render, staticRenderFns } from "./CoreFilesCardNew.vue?vue&type=template&id=2739b524"
import script from "./CoreFilesCardNew.vue?vue&type=script&lang=js"
export * from "./CoreFilesCardNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports